<template>
  <div class="content d-flex flex-column flex-column-fluid" id="kt_content">
    <div v-show="isReady">
      <div class="card mb-5 mb-xxl-8" >
        <!--begin::Body-->
        <div class="card mb-5 mb-xl-10" id="kt_profile_details_view">
          <!--begin::Card header-->
          <div class="card-header flex-wrap border-0 pt-6 pb-0">
            <div class="card-title">
              <h3 class="card-label">{{ $t('store.product.list') }}</h3>
            </div>
            <!-- <div class="card-toolbar">
              <button @click="openModal('createSubmit')" class="btn btn-sm btn-primary m-2" data-bs-toggle="modal"
                data-bs-target="#kt_modal_create_app">{{ $t('store.product.add') }}
              </button>
            </div> -->
          </div>
          <div class="card-body">
            <!--begin::Layout-->
            <div class="row">
              <!--begin::Table-->
              <table class="table align-middle table-row-bordered fs-6 gy-3" id="kt_datatable_store_products">
                <thead>
                <tr class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
                  <th class="min-w-150px">{{ $t('product.name') }}</th>
                  <th class="min-w-100px">{{ $t('product.stock_variable') }}</th>
                  <th class="min-w-100px">{{ $t('product.stock_security') }}</th>
                  <th class="min-w-100px">{{ $t('product.stock_alert') }}</th>
                  <th class="min-w-100px">{{ $t('product.availabily') }}</th>
                  <th class="min-w-100px">{{ $t('action') }}</th>
                </tr>
                </thead>

              </table>
              <!--end::Table-->
            </div>
            <!--end::Layout-->
          </div>
          <!--end::Card body-->
        </div>
        <!--end::Body-->
      </div>
      <div class="modal fade" id="createModal" data-backdrop="static" tabindex="-1" role="dialog"
           aria-labelledby="staticBackdrop" aria-hidden="true">
        <div class="modal-dialog modal-xl">
          <form @submit.prevent="createSubmit" class="form">
            <div class="modal-content ">
              <div class="modal-header add-product-header">
                <h5 class="modal-title">{{ $t('button.add_init_product') }}</h5>
                <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
                  <!--begin::Svg Icon | path: icons/duotune/arrows/arr061.svg-->
                  <span class="svg-icon svg-icon-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                            fill="currentColor" />
                      <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                            fill="currentColor" />
                    </svg>
                  </span>
                  <!--end::Svg Icon-->
                </div>

              </div>
              <div class="modal-body">
                <div class="card-body pt-0">
                  <div class="" data-kt-ecommerce-catalog-add-product="auto-options">
                    <div id="add-product">
                      <div data-kt-scroll="true"
                           data-kt-scroll-height="{default: '100px', lg: '{{scrollHeight}}'}"
                      >
                        <div class="row card-body bg-light mt-4 rounded"
                             v-for="(content, key) in formCreateProductData.productSaleElements" :key="key">
                          <div class="row">
                            <div class="col-md-5 col-sm-12 mb-3">
                              <div class="form-group">
                                <label class="form-label required">{{ $t('product.name') }}</label>
                                <select :data-key="key" required class="form-select kt_select2" data-control="select2"
                                        v-model="content.productSaleElement_id" name="productSaleElements"
                                        data-placeholder="Selectionnez un produit" data-allow-clear="false" data-search="true"
                                        data-dropdown-parent="#createModal"
                                >
                                  <option></option>
                                  <option v-for="product in productSaleElement" :key="product.id" :value="product.id">
                                    {{ product.name }}{{ formatProduct(product) }}</option>
                                </select>
                              </div>
                            </div>
                            <div class="col-md-2 col-sm-12 mb-3">
                              <label class="form-label required"> {{ $t('product.stock') }}</label>
                              <input type="number" :id="'stock_initial_'+key" :name="'stock_initial_'+key" @input="formatNumber" class="form-control" min="0" v-model="content.stock_initial"
                                     required />
                            </div>
                            <div class="col-md-2 col-sm-12 mb-3">
                              <label class="form-label required"> {{ $t('product.stock_alert') }}</label>
                              <input type="number" @input="formatNumber" class="form-control" min="0" v-model="content.stock_alert"
                                     required />
                            </div>
                            <div class="col-md-2 col-sm-12 mb-3">
                              <label class="form-label required"> {{ $t('product.stock_security') }}</label>
                              <input type="number" class="form-control" min="0" v-model="content.stock_security" required />
                            </div>
                            <div class="col-md-1 col-sm-12 mt-10">
                              <button @click.prevent="dropProductLigne(key)" type="button"
                                      class="btn btn-sm btn-light-danger">
                                <span class="svg-icon svg-icon-2">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                       fill="none" data-v-b49ffb9c="">
                                    <path
                                        d="M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z"
                                        fill="currentColor" data-v-b49ffb9c=""></path>
                                    <path opacity="0.5"
                                          d="M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z"
                                          fill="currentColor" data-v-b49ffb9c=""></path>
                                    <path opacity="0.5"
                                          d="M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z"
                                          fill="currentColor" data-v-b49ffb9c=""></path>
                                  </svg>
                                </span>
                              </button>
                            </div>
                          </div>
                        </div>

                        <div class="form-group mt-3">
                          <button @click.prevent="addProductLigne" type="button" class="btn btn-sm btn-light-primary">
                            <span class="svg-icon svg-icon-2">
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <rect opacity="0.5" x="11" y="18" width="12" height="2" rx="1" transform="rotate(-90 11 18)"
                                      fill="currentColor" />
                                <rect x="6" y="11" width="12" height="2" rx="1" fill="currentColor" />
                              </svg>
                            </span>
                            {{ $t('product.add_product') }}</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal">{{ $t('button.close') }}</button>
                <button type="submit" class="btn btn-sm btn-primary" :disabled="isLoading">
                  <span class="indicator-label" v-if="!isLoading">{{ $t('button.save') }}</span>
                  <span class="" v-else>{{ $t('loading') }}
                    <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                  </span>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="modal fade" id="updateProductModal" data-backdrop="static" tabindex="-1" role="dialog"
           aria-labelledby="staticBackdrop" aria-hidden="true">
        <div class="modal-dialog">
          <form @submit.prevent="UpdateProductStockData" class="form">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">{{ $t('product.edit_product') }}</h5>
                <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
                  <span class="svg-icon svg-icon-2x">X</span>
                </div>
              </div>
              <div class="modal-body">
                <div class="row">
                  <div class="col-sm-12">
                    <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                      <span>{{ $t('product.name') }}</span>
                    </label>
                    <input type="text" readonly class="form-control" v-model="formProductEditData.name" required />
                  </div>
                  <div class="col-sm-6 mt-4">
                    <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                      <span class="required">{{ $t('product.stock_security') }}</span>
                    </label>
                    <input type="number" class="form-control" min="0" v-model="formProductEditData.stock_security" required />
                  </div>
                  <div class="col-sm-6 mt-4">
                    <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                      <span class="required">{{ $t('product.stock_alert') }}</span>
                    </label>
                    <input type="number" class="form-control" min="0" v-model="formProductEditData.stock_alert" required />
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal">{{ $t('button.close') }}</button>
                <button type="submit" class="btn btn-sm btn-primary"
                        :class="{ 'spinner spinner-left spinner-dark pl-15': isLoading }" :disabled="isLoading">{{
                    $t('button.save') }}</button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="modal fade" tabindex="-1" id="contactCreateModal">
        <div class="modal-dialog modal-xl">
          <create-contact
              id="1"
              :get-countries="getCountries"
              :contact="formCreateData"
              :modal="true"
              @success="loadFilter"
          >
          </create-contact>
        </div>
      </div>
    </div>
    <div class="container-xxl" v-show="!isReady">
      <Loader />
    </div>
  </div>
</template>

<script>
import { BASE_URL } from "@/services/api";
import AppSubHeader from "@/views/Settings/Stores/partials/AppSubHeader";
import Select from "@/components/General/Select.vue";
import CreateContact from "@/components/CreateContact";
import Loader from "@/components/Loader.vue";
import { mapActions, mapGetters } from 'vuex';
export default {
  name: "Products",
  components: {
    AppSubHeader,
    Select,
    CreateContact,
    Loader
  },
  data() {
    return {
      productSaleElement: {},
      products: {},
      product_sale_element: {},
      storeProductSaleElement: [],
      isLoading: false,
      formCreateProductData: {
        id: this.$route.params.id,
        totalNumber: 0,
        prefixe: "",
        productSaleElements: [
          {
            productSaleElement_id: "",
            stock_initial: 0,
            stock_alert: 0,
            stock_security: 0,
            comments: ''
          }
        ],
      },
      formCreateData: {
        id : null,
        gender : null,
        contactType: 'particular',
        name: null,
        address: {
          street: null,
          street2: null,
          city: null,
          zipcode: null,
          country: null
        },
        customer: true,
        birthday: null,
        supplier: true,
        telephone: null,
        phoneCode: null,
        previewAvatar: 'http://net.pos.localhost/assets/blank.png',
        email:null,
        website: null
      },
      formProductEditData: {
        id: null,
        name: '',
        stock_security: '',
        stock_alert: '',
        row: null
      },
      formProductDeleteData: {
        id: null,
        row: null
      },
      numberEnt: '',
      formAvailableProduct: {
        id: null,
        product_sale_element_id: null,
        available: false
      },
      stock: 0,
      scrollHeight: 300,
      isReady: false
    }
  },
  watch: {
    'formCreateProductData.productSaleElements.length': function () {
      this.$nextTick(() => {
        this.initSelect2()
        $(".kt_voucher_date").flatpickr({
          dateFormat: "d/m/Y",
        })
      })
    }
  },
  async mounted() {
    this.isReady = false

    KTScroll.createInstances();
    this.loadContactSupplier()
    this.loadCurrencies()
    this.fetchDatas();

    $(".kt_voucher_date").flatpickr({
      dateFormat: "d/m/Y",
    })
    this.initSelect2()
    this.loadData()
    let resp = await this.numberEntryOutput()
    this.numberEnt = resp.data.entryNumber

    if(this.$route.params.id){
      await this.getProductSale(this.$route.params.id)
    }
    this.isReady = true
    // Le tableau a été initialisé caché (largeur 0) : on recalcule les colonnes visibles
    this.$nextTick(() => this.table?.columns.adjust().responsive.recalc())

    $(document).on("click", "#kt_datatable_store_products .delete_btn", (e) => {
      if(this.store?.etat == 'active'){
        this.formProductDeleteData.id = e.target.getAttribute('data-id')
        this.formProductDeleteData.row = e.target.getAttribute('data-row')
        this.stock = e.target.getAttribute('data-stock')
        this.removeProductRow(this.stock)
      }
    });

    $(document).on("click", "#kt_datatable_store_products .edit_btn", (e) => {
      if(this.store?.etat == 'active'){
        this.formProductEditData.id = e.target.getAttribute('data-id')
        this.formProductEditData.name = e.target.getAttribute('data-name')
        this.formProductEditData.stock_security = e.target.getAttribute('data-stock-security')
        this.formProductEditData.stock_alert = e.target.getAttribute('data-stock-alert')
        this.formProductEditData.row = e.target.getAttribute('data-row')
        $('#updateProductModal').modal('toggle')
      }
    });

    $(document).on("click", "#kt_datatable_store_products .available", (e) => {
      if(this.store?.etat == 'active'){
        this.formAvailableProduct.id = this.$route.params.id
        this.formAvailableProduct.product_sale_element_id = e.target.getAttribute('data-id')
        this.formAvailableProduct.available = (e.target.getAttribute('data-available') == "true") ? false : true
        this.changeProductAvailableData()
      }
    });
  },
  computed: {
    ...mapGetters('contacts', ['getContactSuppliers']),
    ...mapGetters('currencies', ['getCurrencies']),
    ...mapGetters('countries', ['getCountries']),

    updateOrCreate() {
      return (this.submitType == 'createSubmit') ? false : true;
    }
  },
  methods: {
    ...mapActions('contacts', ['loadContactSupplier']),
    ...mapActions('currencies', ['loadCurrencies']),
    ...mapActions('store', ['showStore', 'numberEntryOutput', 'getStoreProductSaleEment', 'updateStoreProductAvailable']),
    ...mapActions('products', ['loadProductSale', 'addProductStore', 'removeProductStore', 'updateProductStore', 'getInitialisationStoreProduct']),

    fetchDatas() {
      const AUTH_TOKEN = Ls.get('auth.token')

      this.table = $("#kt_datatable_store_products").DataTable({
        responsive: !0,
        searchDelay: 500,
        processing: !0,
        serverSide: !0,
        pageLength: Ls.get('pageLength') ?? 10,
        lengthMenu: [5, 10, 25, 50, 75, 100],
        order: [[1, 'asc']],
        ajax: {
          url: BASE_URL + "/get/stores/" + this.$route.params.id + "/products/datatables",
          type: "GET",
          beforeSend: function (request) {
            request.setRequestHeader("Authorization", "Bearer " + AUTH_TOKEN);
          },
          data: function (d) {
          }
        },
        columns: [
          { data: "name" }, { data: "stock_variable" }, { data: "stock_security" }, { data: "stock_alert" }, { data: "available" }, { data: "Actions", responsivePriority: -1 }
        ],
        columnDefs: [
          {
            targets: -6,
            order: "desc",
            className: "dt-center clickable",
            render: function (t, a, e, l) {
              return '<span data-id="' + e.id + '"  class="typeRow' + l.row + '">' + t + "</span>";
            },
          },
          {
            targets: -5,
            className: "text-center clickable",
            render: (t, a, e, l) => {
              let number = this.$formatNumber((t || 0).toString())
              return '<span data-id="' + e.id + '" class="titleRow' + l.row + '">' + number + "</span>";
            },
          },
          {
            targets: -4,
            className: "text-center clickable",
            render: (t, a, e, l) => {
              let number = this.$formatNumber((t || 0).toString())
              return '<span data-id="' + e.id + '" class="amountRow' + l.row + '">' + number + "</span>";
            },
          },
          {
            targets: -3,
            order: "desc",
            className: "text-center clickable",
            render: (t, a, e, l) => {
              let number = this.$formatNumber((t || 0).toString())
              return '<span data-id="' + e.id + '"  class="typeRow' + l.row + '">' + number + "</span>";
            },
          },
          {
            targets: -2,
            order: "desc",
            render: function (t, a, e, l) {
              if(e.available){
                return '<span class="form-check form-switch form-check-custom form-check-solid visibleRow'+ l.row +'"><label><input type="checkbox" checked data-id="'+ e.id +'" id="'+ e.id +'" data-available="'+ e.available +'"  class="form-check-input available h-20px w-30px"/><span></span></label></span>';
              }else{
                return '<span class="form-check form-switch form-check-custom form-check-solid visibleRow'+ l.row +'"><label> <input type="checkbox" data-id="'+ e.id +'" data-available="'+ e.available +'"  id="'+ e.id +'" class="form-check-input available h-20px w-30px"/><span></span></label></span>';
              }
            },

          },
          {
            targets: -1,
            "className": "text-center",
            title: "Actions",
            orderable: !1,
            render: (t, a, e, l) => {
              let render = ""
              if(this.$can('product_magasin_update')  ){
                render += '<a href="javascript:;" data-name="' + e.name + '" data-row="' + l.row + '"  data-id="' + e.id + '" data-stock-initial="' + e.stock_initial + '"data-stock-security="' + e.stock_security + '"data-stock-alert="' + e.stock_alert + '" class="btn btn-sm btn-clean btn-icon edit_btn"><i data-row="' + l.row + '" data-id="' + e.id + '" data-name="' + e.name + '" data-price="' + e.price + '" data-stock-initial="' + e.stock_initial + '" data-stock-variable="' + e.stock_variable + '"data-stock-security="' + e.stock_security + '"data-stock-alert="' + e.stock_alert + '"" class="la la-edit fs-2"></i></a>'
              }
              if(this.$can('product_magasin_delete')  ){
                render += '<a href="javascript:;" data-row="' + l.row + '" data-id="' + e.id + '" data-stock="' + e.stock_variable + '" class="btn btn-sm btn-clean btn-icon delete_btn" title="delete"><i data-row="' + l.row + '" data-id="' + e.id + '" data-stock="' + e.stock_variable + '" class="la la-trash fs-2"></i></a>'
              }
              return render
            },
          },

        ],
        language: {
          url: this.$i18n?.locale == 'fr' ? "//cdn.datatables.net/plug-ins/1.10.20/i18n/French.json" : "//cdn.datatables.net/plug-ins/1.10.20/i18n/English.json",
        }
      });
    },

    async loadData() {
      let response = await this.showStore(this.$route.params.id)
      this.store = response.data.store
    },

    createContactModalOpen(){
      $('#contactCreateModal').modal('toggle')
    },

    async loadFilter(){
      this.$startLoadingPage()
      await this.loadContactSupplier()
      this.$endLoadingPage()
    },

    async getProductSale(id) {
      let response = await this.getInitialisationStoreProduct(id)
      this.product_sale_element = response.data.product_sale_element
      this.products = response.data.products
      let respo = await this.getStoreProductSaleEment(id)
      this.storeProductSaleElement = respo.data
      this.productSaleElement = this.getProductNotSale()
    },

    getProductNotSale() {
      let productNotSalte = this.product_sale_element
      for (let y = 0; y < this.storeProductSaleElement.length; y++) {
        for (let z = 0; z < productNotSalte.length; z++) {
          if (this.storeProductSaleElement[y].id === productNotSalte[z].id) {
            productNotSalte.splice(z, 1)
          }
        }
      }
      return productNotSalte
    },

    openModal(type) {
      this.submitType = type
      $('#createModal').modal('toggle')
    },

    async createSubmit() {
      this.isLoading = true
      try {
        this.formCreateProductData.totalNumber = this.numberEnt,
            this.formCreateProductData.prefixe = this.store.prefixe + '-ENT-',
            await this.addProductStore(this.formCreateProductData)
        window.toastr['success'](i18n.global.t('notification.store.product_add'))
        this.table.ajax.reload();
        this.isLoading = false
        $('#createModal').modal('toggle')

        this.formCreateProductData.productSaleElements = [
          {
            productSaleElement_id: "",
            stock_initial: 0,
            stock_alert: 0,
            stock_security: 0,
            comments: ''
          }
        ]
        await this.loadProductSale(this.$route.params.id)
        if(this.$route.params.id){
          await this.getProductSale(this.$route.params.id)
        }
      } catch (e) {
        this.isLoading = false
      }
    },

    async UpdateProductStockData() {
      let data = {
        product_sale_element_id: this.formProductEditData.id,
        stock_security: this.formProductEditData.stock_security,
        stock_alert: this.formProductEditData.stock_alert,
        id: this.$route.params.id
      }
      let response = {}

      try {
        response = await this.updateProductStore(data)
        this.isLoading = false
        window.toastr['success'](i18n.global.t("notification.store.product_update"))
        this.table.ajax.reload()
        $('#updateProductModal').modal('toggle')
        this.formProductEditData = {
          stock_alert: 0,
          stock_security: 0,
        }
        // if(this.$route.params.id){
        //   await this.getProductSale(this.$route.params.id)
        // }
        return true
      } catch (e) {
        this.isLoading = false
        if (response && response.data) {
          window.toastr['error'](response.data.error)
          return true
        }
      }
    },

    async removeProductRow(stock) {
      Swal.fire({
        title: i18n.global.t('store.product.notification.title'),
        text: i18n.global.t('store.product.notification.subtitle'),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: i18n.global.t('store.product.notification.yes'),
        cancelButtonText: i18n.global.t('store.product.notification.no'),
      }).then(async (result) => {
        if (result.value) {
          try {
            if(stock == 0){
              let data = {
                product_sale_element_id: this.formProductDeleteData.id,
                id: this.$route.params.id
              }
              await this.removeProductStore(data)
              window.toastr['success'](i18n.global.t("notification.store.product_delete"))
              if(this.$route.params.id){
                await this.getProductSale(this.$route.params.id)
              }
              this.table.ajax.reload()
              this.loadData()
              return true
            }
            if(stock > 0){
              this.removeProductWithRow(stock)
            }
            this.loadData()
          } catch (e) {
            console.log(e)
          }
        }
      });
    },

    async removeProductWithRow(stock) {
      Swal.fire({
        title: i18n.global.t('store.product.notification.title_stock') + stock,
        text: i18n.global.t('store.product.notification.subtitle_stock'),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: i18n.global.t('store.product.notification.yes'),
        cancelButtonText: i18n.global.t('store.product.notification.no'),
      }).then(async (result) => {
        if (result.value) {
          try {
            let data = {
              product_sale_element_id: this.formProductDeleteData.id,
              id: this.$route.params.id
            }
            await this.removeProductStore(data)
            window.toastr['success'](i18n.global.t("notification.store.product_delete"))
            if(this.$route.params.id){
              await this.getProductSale(this.$route.params.id)
            }
            this.loadData()
            this.table.ajax.reload()
            return true
          } catch (e) {
            console.log(e)
          }
        }
      });
    },

    dropProductLigne(key) {
      if(this.formCreateProductData.productSaleElements.length > 1){
        this.formCreateProductData.productSaleElements.splice(key, 1);
      }
    },

    addProductLigne() {
      this.formCreateProductData.productSaleElements.push({
        productSaleElement_id: "",
        stock_initial: 0,
        stock_alert: 0,
        stock_security: 0,
        stock_variable: 0,
        comments: ''
      })

      $("#createModal").on("shown.bs.modal", function () {
        let count = this.formCreateProductData.productSaleElements.length
        //$(this).find("#stock_initial"+count-1).focus();
        $('input[name="#stock_initial_"' + count-1 + ']').focus();
      });
    },

    formatProduct(items) {
      return (items.attribut.length > 0) ? ' | ' + items.attribut + ' ' : '';
    },

    initSelect2() {
      KTApp.initSelect2()
      let kt_select2 = $(".kt_select2")
      kt_select2.select2()
      kt_select2.select2().select2()

      kt_select2.change((e) => {
        switch (e.target.name) {
          case 'productSaleElements':
            this.formCreateProductData.productSaleElements[e.target.getAttribute('data-key')].productSaleElement_id = e.target.value
            break;
          case 'product_sale_element':
            this.formCreateProductData.productSaleElements[e.target.getAttribute('data-key')].product_sale_element_id = e.target.value
            break;
          default:
            break;
        }
      });
    },

    changeProductAvailableData() {
      console.log("in function")
      this.updateStoreProductAvailable(this.formAvailableProduct).then((response) => {
        this.isLoading = false
        window.toastr['success'](i18n.global.t("notification.store.change_available"))
        this.formAvailableProduct = {
          id: null,
          product_sale_element_id: null,
          available: false
        }
        this.table.ajax.reload()
      }).catch((err) => {
        this.isLoading = false
        if (err && err.data) {
          window.toastr['error'](err.data.error)
        }
      })
    },
  }
}
</script>

<style scoped>
.add-product-header {
  position: sticky;
  top: 0;
  background-color: #fff;
  z-index: 9999;
  padding: 10px;
}

#add-product {
  overflow: auto;
  height: 300px !important;
}
</style>